"use client"

import { useState, useEffect } from "react"
import axios from "axios"
import { Link } from "react-router-dom"
import { motion, AnimatePresence } from "framer-motion"
import { Mail, KeyRound, ArrowLeft, AlertCircle, CheckCircle, Send } from "lucide-react"
import "../styles/recuperacaoSenha.css"

function RecuperarSenha() {
  const [email, setEmail] = useState("")
  const [mensagem, setMensagem] = useState("")
  const [tipo, setTipo] = useState("") // 'sucesso' ou 'erro'
  const [isLoading, setIsLoading] = useState(false)

  // Efeito para animação de partículas
  useEffect(() => {
    const canvas = document.getElementById("particles-recuperar")
    if (!canvas) return

    const ctx = canvas.getContext("2d")
    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    const particles = []
    const particleCount = 50

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 2 + 1,
        color: "rgba(255, 193, 7, " + (Math.random() * 0.3 + 0.2) + ")",
        speedX: Math.random() * 0.5 - 0.25,
        speedY: Math.random() * 0.5 - 0.25,
      })
    }

    function animate() {
      requestAnimationFrame(animate)
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      for (let i = 0; i < particleCount; i++) {
        const p = particles[i]
        ctx.beginPath()
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2)
        ctx.fillStyle = p.color
        ctx.fill()

        p.x += p.speedX
        p.y += p.speedY

        if (p.x < 0 || p.x > canvas.width) p.speedX *= -1
        if (p.y < 0 || p.y > canvas.height) p.speedY *= -1
      }
    }

    animate()

    const handleResize = () => {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMensagem("")
    setIsLoading(true)

    try {
      await axios.post("https://api.ticketdovaqueiro.com/api/auth/recuperar-senha", { email })
      setTipo("sucesso")
      setMensagem("E-mail enviado com instruções para recuperar sua senha!")
    } catch (err) {
      setTipo("erro")
      setMensagem("Erro ao enviar e-mail. Verifique se o endereço está correto.")
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="recuperar-page">
      <canvas id="particles-recuperar" className="particles-canvas"></canvas>

      <div className="recuperar-overlay">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="recuperar-container"
        >
          <div className="recuperar-header">
            <motion.div whileHover={{ x: -5 }} className="back-button">
              <Link to="/login">
                <ArrowLeft size={20} />
                <span>Voltar para login</span>
              </Link>
            </motion.div>

            <motion.h1
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="recuperar-title"
            >
              <KeyRound className="recuperar-icon" />
              Recuperar Senha
            </motion.h1>
          </div>

          <div className="recuperar-content">
            <div className="recuperar-description">
              <p>Digite seu e-mail abaixo e enviaremos instruções para redefinir sua senha.</p>
            </div>

            <AnimatePresence>
              {mensagem && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  className={`recuperar-message ${tipo === "sucesso" ? "recuperar-success" : "recuperar-error"}`}
                >
                  {tipo === "sucesso" ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
                  {mensagem}
                </motion.div>
              )}
            </AnimatePresence>

            <form onSubmit={handleSubmit} className="recuperar-form">
              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <div className="input-wrapper">
                  <Mail className="input-icon" />
                  <input
                    type="email"
                    id="email"
                    placeholder="Digite seu e-mail cadastrado"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                type="submit"
                className="recuperar-button"
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="button-loader"></div>
                ) : (
                  <>
                    ENVIAR INSTRUÇÕES
                    <Send size={18} />
                  </>
                )}
              </motion.button>
            </form>

            <div className="recuperar-footer">
              <p>
                Lembrou sua senha?{" "}
                <Link to="/login" className="login-link">
                  Faça login
                </Link>
              </p>
            </div>
          </div>
        </motion.div>

        <div className="recuperar-page-footer">
          <p>© {new Date().getFullYear()} Ticket do Vaqueiro - Todos os direitos reservados</p>
        </div>
      </div>
    </div>
  )
}

export default RecuperarSenha

